import { render, staticRenderFns } from "./department-form.vue?vue&type=template&id=0efd5fcc"
import script from "./department-form.vue?vue&type=script&lang=js"
export * from "./department-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports